import { render, staticRenderFns } from "./EditVenue.vue?vue&type=template&id=8d3548ee"
import script from "./EditVenue.vue?vue&type=script&lang=ts"
export * from "./EditVenue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports